import { useState, useEffect } from "react";
import "./styles/pay.scss";
import CreditCard from "./component/creditcard.js";
import axios from 'axios';
import { backend } from '../../components/apipath';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { usePayment } from "../../components/PaymentContext";

function Pay() {
    const { step, setStep } = usePayment();

    useEffect(() => {
        console.log("Current step in pay.js:", step);
        console.log("LocalStorage step:", localStorage.getItem("paymentStep"));
    
        const savedStep = parseInt(localStorage.getItem("paymentStep")) || 0;
    
        if (step < 3 && savedStep < 3) {
            console.log("Redirecting to /registration/payinfo...");
            navigate("/registration/payinfo");
        }
    }, [step]);
    
    

    const [coupon, setCoupon] = useState('');
    const [couponInfo, setCouponInfo] = useState(null);
    const checkCoupon = async () => {
        const res = await fetch(`${backend}order/checkCoupon`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code: coupon })
        });
        const data = await res.json();
        if (data.success) {
          setCouponInfo(data);
        } else {
            Swal.fire({
                icon: 'error',
                title: '優惠碼錯誤',
                text: data.message || '查無此優惠碼，請重新確認！',
              });
        }
      };
    const calculateDiscountedPrice = (price) => {
    if (!couponInfo) return price;
    const discount = parseFloat(couponInfo.data.discount || 0);
    return Math.max(0, price - discount);
    };
    const [planData, setPlanData] =useState(null);
    const [paymentMethod, setPaymentMethod] = useState("ATM");
    const [inputs, setInputs] = useState({});
    const navigate = useNavigate();
    const selectedPlan = localStorage.getItem('selectedPlan');
    const handlePaymentMethodChange = (method) => {
        setPaymentMethod(method);
    };

    useEffect(() => {
        const selectedPlan = localStorage.getItem('selectedPlan');
        const fetchPlanDetails = async () => {
            try {
                const response = await axios.get(`${backend}product/${selectedPlan}`);
                setPlanData(response.data.data[0]);
            } catch (error) {
                console.error('Error fetching plan details:', error);
            }
        };
        fetchPlanDetails();
    }, []);

    const handleSubmit = async () => {
        const form_data = JSON.parse(localStorage.getItem("formData"));
        const mem_data = JSON.parse(localStorage.getItem("auth"));
        const transfer_date = document.getElementById("payment")?.value || null;
        const transfer_name = document.getElementById("payer")?.value || null;
        const order_date = new Date().toISOString().split('T')[0];
    
        const expMonths = planData?.exp ? parseInt(planData.exp, 10) : 12; // 預設12個月
        const software_ex = new Date();
    
        if (!isNaN(expMonths)) {
            software_ex.setMonth(software_ex.getMonth() + expMonths);
        }
    
        let finalPrice = calculateDiscountedPrice(planData?.price || 0);
    
        const coupon = couponInfo;
    
        const requestData = {
            mem_id: mem_data.mem_id,
            product_id: planData.product_id,
            total_price: finalPrice,
            discount_id: coupon?.type === 'discount' ? coupon.data.discount_id : null,
            mou_id: coupon?.type === 'mou' ? coupon.data.mou_id : null,
            partner_id: null,
            tax_num: form_data.tax_num || null,
            company: form_data.company || null,
            deliver: Array.isArray(form_data.deliver) ? form_data.deliver.join(",") : "",
            software_ex: !isNaN(software_ex.getTime()) ? software_ex.toISOString().split('T')[0] : null,
            extension: null,
            memo: null,
            order_date: order_date,
            transfer_date: transfer_date,
            transfer_name: transfer_name,
            deliver: Array.isArray(form_data.deliver) ? form_data.deliver.join(",") : "",
            book: Array.isArray(form_data.book) ? form_data.book.join(",") : "",
            course: Array.isArray(form_data.course) ? form_data.course.join(",") : "",
            info_way: Array.isArray(form_data.info_way) ? form_data.info_way.join(",") : "",
            address: form_data.address || null,
        };
    
        try {
            const response = await axios.post(`${backend}order/create-order`, requestData, {
                headers: { "Content-Type": "application/json" },
            });
    
            Swal.fire({
                title: '購買成功',
                text: '感謝您的購買！系統將自動返回首頁。',
                icon: 'success',
                confirmButtonText: '確定',
                timer: 3000,
                timerProgressBar: true,
                willClose: () => {
                    window.location.href = '/';
                },
            });
        } catch (error) {
            console.error('Error creating order:', error.response?.data || error.message);
    
            Swal.fire({
                title: '購買失敗',
                text: '無法完成您的購買，請稍後再試。',
                icon: 'error',
                confirmButtonText: '確定',
            });
        }
    };
    
    return (
        <>
            <div className="container mb100 mt100">
                <div className="beckertitlename mt100 mb-5">付款資訊</div>
                <div className="card w-75 p-5 m-auto">
                    <div className="form-group mb-4">
                            <div>
                            {planData ? (
                                <div className="plan-details mb-5">
                                    <div className="mt-3">
                                        <h4>購買方案</h4>
                                        {planData.name}
                                    </div>
                                    <div className="mt-3">
                                        <h4>方案內容</h4>
                                        <div className="card-body" dangerouslySetInnerHTML={{ __html: planData.content }}></div>
                                    </div>
                                    <div className="mt-3">
                                    <h4>方案價格</h4>
                                    $ {planData.price} 元
                                    </div>

                                    <div className="mt-3">
                                    <label>優惠碼</label>
                                    <div className="d-flex gap-2">
                                        <input
                                        type="text"
                                        className="form-control"
                                        placeholder="請輸入優惠碼"
                                        value={coupon}
                                        onChange={(e) => setCoupon(e.target.value)}
                                        style={{ maxWidth: "200px" }}
                                        />
                                        <button className="btn btn-outline-primary" onClick={checkCoupon}>
                                        輸入
                                        </button>
                                    </div>
                                    {couponInfo && (
                                    <div className="text-success mt-2">
                                        成功套用優惠碼：{couponInfo.data.code}，折抵 NT${couponInfo.data.discount}
                                    </div>
                                    )}
                                    </div>

                                    <div className="mt-3">
                                    <h4>折扣後金額</h4>
                                    <strong>$ {calculateDiscountedPrice(planData.price)} 元</strong>
                                    </div>
                                </div>
                            ) : (
                                <p>加载中...</p>
                            )}
                            </div>
                        <label  className="mb-5">付款方式</label>
                        <div className="middle">
                            <label>
                                <input type="radio" name="radio" checked={paymentMethod === "ATM"}
                                onChange={() => handlePaymentMethodChange("ATM")} />
                                <div className="front-end box">
                                <span>ATM轉帳</span>
                                </div>
                            </label>

                            {/* <label>
                                <input type="radio" name="radio" checked={paymentMethod === "CreditCard"}
                                onChange={() => handlePaymentMethodChange("CreditCard")}/>
                                <div className="back-end box">
                                <span>信用卡付款</span>
                                </div>
                            </label> */}
                        </div>
                    </div>
                    {paymentMethod === "ATM" && (
                    <div className="atm">
                        <div className="card-body">
                            付費購買匯款資訊<br/>
                            【在台購買】<br/>
                            收款人戶名：捷進顧問有限公司<br/>
                            受款銀行：華南商業銀行信維分行 (代碼：008 )<br/>
                            收款人帳號：149-10-010062-0<br/><br/>

                            匯款金額：以新台幣付費，依各方案價格 (若需快遞書籍，請加上運費)<br/>
                            快遞計費方式：單箱最多可裝 2 科書籍，每箱快遞費 TWD 100 元。<br/>
                            __________________<br/><br/>

                            【海外購買】<br/>
                            Recipient Name: Direct Line Consulting Co.<br/>
                            Account Number: 149-10-010062-0<br/><br/>

                            Bank: Hua Nan Commercial Bank Ltd.<br/>
                            Branch: Hsin-Wei Branch<br/>
                            SWIFT Code (Bank ID): 
                            <br/><br/>
                            HNBKTWTP149<br/>


                            Bank Address: 2F, No.6, Xinyi Rd. Sec. 4, Da'an Dist., 106 Taipei City, Taiwan<br/><br/>

                            匯款金額：以新台幣付費，依各方案價格 (全額到匯)
                        </div>
                        <form>
                            {/* <div className="form-group mb-4">
                                <label  className="mb-2">繳費金額</label>
                                <input type="text" className="form-control" id="payment" />
                                <small id="nameHelp" className="form-text text-muted">請填入您已匯款/轉帳之金額</small>
                            </div> */}
                            <div className="form-group mb-4">
                                <label  className="mb-2">匯款 / 轉帳日期</label>
                                <input type="date" className="form-control" id="payment" />
                                <small id="nameHelp" className="form-text text-muted">Becker Taiwan 將依此核對確認您的款項</small>
                            </div>
                            <div className="form-group mb-4">
                                <label  className="mb-2">匯款 (存款) 人姓名、或轉出帳戶後五碼</label>
                                <input type="text" className="form-control" id="payer" />
                            </div>
                        </form>
                        <button className="btn btn-primary" onClick={handleSubmit}>
                            送出
                        </button>
                    </div>
                    )}
                    {paymentMethod === "CreditCard" && (
                        <CreditCard setInputs={setInputs} inputs={inputs} handleSubmit={handleSubmit}/>
                    )}
                </div>
            </div>
        </>
    );
}
export default Pay;